import styled from 'styled-components';


export const PContent = styled.div`
    font-size:2rem;
    width: 90vw;
    max-width: 700px;
    margin: 0 auto;

`;

export const Pbloco = styled.div`
position: relative;
padding:10px;
margin-top:20px;
border: red 1px solid;
h1+div {
    padding: 10px;
    display:flex;
    justify-content: space-between;
    align-items: center;
}
i {
    border: black 1px solid;
    padding: 10px;
    border-radius:30%;
}
h1 {

}
h2 {

}

&>div {

}
`;

export const Alternativa = styled.div`
    padding:1px;

    :before {
        content:"-- ";
    }
    ${props=>props.correta&&
        "color:green;"+
        "font-weight: bold;"
    }

`
